module.exports = __webpack_public_path__ + "static/media/design6.5d801969.jpg";